import * as React from "react";
import { connect } from "react-redux";
import SectionLoading from "../common/SectionLoading";
import SectionLoadingError from "../common/SectionLoadingError";
import EVisitGetStarted from "./EVisitGetStarted";
import EVisitInEligible from "./EVisitInEligible";
import * as d from "../../reducers/domainReducer";
import { getFirstName } from "../../helpers/formatting";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import * as types from "../../constants/actionTypes";
import FeatureDisabled from "../common/FeatureDisabled";
import EVisitNeedsAccount from "./EVisitNeedsAccount";

class EVisit_latest extends React.Component {
    constructor(props) {
        super(props);
        this.unexpectedErrorMessage = "Sorry, we are not able to load your eVisit. Please schedule an appointment using other options available on MyBSWHealth.";
        this.shouldLoadEVistPage = this.shouldLoadEVistPage.bind(this);
        this.ourCallback = this.ourCallback.bind(this);
        this.state = { activeUserIndex: 0, userSelected: null };
    }

    componentDidMount() {
        logUI("MBHWeb.UI.EVisit.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    shouldLoadEVistPage() {
        this.setState({ loadEVisit: true });
    }

    onUserSelected = userSelected => {

    }

    ourCallback() {
        const { userSelected } = this.state;
        const activeUserIndex = userSelected.index ? userSelected.index : 0;
        if (this.state.activeUserIndex === activeUserIndex) {
            this.setState({ activeUserIndex, userSelected });
        }
        else {
            this.setState({ activeUserIndex });
        }
    }

    onUserSwitched = (userSelected, index) => {
        this.setState({ userSelected });
        this.props.switchToMyChartUser(userSelected, index, this.ourCallback);
    }

    userTags = () => {
        const { eVisit, hasAAL } = this.props;
        // eVisitCost is now a string, but if we want to preserve this tag system, we have to remove the $ and convert to a num
        /*let eVisitCostNum = eVisitCost.replace('$', '')
        let tags = '';
        if (!isNaN(+eVisitCostNum)) {
            tags += eVisitCost === 0 ? '.SWHPCovered' : '.SWHPNonCovered';
        }*/
        let tags = '';
        if (eVisit && eVisit.BswZipGroup) {
            tags += eVisit.bswZipGroup.Price === 0 ? '.SWHPCovered' : '.SWHPNonCovered';
        }
        if (hasAAL) {
            tags += '.AAL';
        }
        return tags;
    }

    render() {
        const { loading, failure, hasMyChart, epicEHRDown, activeProfile, primaryUser, currentUser, myProxies, technicalHelpDeskNumber, technicalHelpDeskHours, zipnosis, userIsSwitching, isActiveFeature_EVisit, eVisit, location } = this.props;

        const isFromCovid19ScreenerSurvey = location && location.state && location.state.isFromCovid19ScreenerSurvey ? true : false;

        if (userIsSwitching) {
            return null;
        }

        if (hasMyChart && epicEHRDown) {
            return <FeatureDisabled />;
        }

        const userData = activeProfile
        const { userSelected } = this.state;
        let isProxyAvailable = myProxies && myProxies.length > 1 ? true : false;
        const eVisitmessage = "Who is this for?";
        const isMinor = (currentUser && !currentUser.index && primaryUser.isMinor) || (currentUser && currentUser.index && currentUser.ageYears < 18);

        let heading = 'eVisit';
        let activeUserFirstName = '';
        if (currentUser && typeof primaryUser.externalId !== 'undefined' &&
            currentUser.externalId !== primaryUser.externalId && currentUser.displayName) {
            activeUserFirstName = getFirstName(currentUser.displayName);
            heading += ' (' + activeUserFirstName + ')';
        }

        let body = null;
        if (loading) {
            body = (<div className="row">
                <div className="col-12 maxWidth-content">
                    <h1 className="page-heading">{heading}</h1>
                    <SectionLoading />
                </div>
            </div>);
        }
        else if (failure || (zipnosis && zipnosis.error)) {
            body =
                (<div id="evisit-action" className="row">
                    <div className="col-12 maxWidth-content">
                        <h1 className="page-heading">{heading}</h1>
                        <SectionLoadingError message={this.unexpectedErrorMessage} />
                    </div>
                </div>);
        }
        else if (isActiveFeature_EVisit) {
            if (currentUser && currentUser.index && currentUser.ageYears > 17) {
                body = (<div className="row">
                    <div className="col-12 maxWidth-content">
                        <h1 className="page-heading">{heading}</h1>
                        <EVisitNeedsAccount registrationUrl={serverData.data.myChartRegistrationUrl} technicalHelpDeskHours={technicalHelpDeskHours} technicalHelpDeskNumber={technicalHelpDeskNumber} userData={userData} userTags={this.userTags} />
                    </div>
                </div>);
            }
            else  {
                body = <EVisitGetStarted userData={userData} isPrimaryUser={!currentUser.index} heading={heading} activeUserFirstName={activeUserFirstName} userTags={this.userTags} />;
            }
        }
        else {
            body = (<div className="row">
                <div className="col-12 maxWidth-content">
                    <h1 className="page-heading">{heading}</h1>
                    <EVisitInEligible isMinor={isMinor} technicalHelpDeskHours={technicalHelpDeskHours} isFromCovid19ScreenerSurvey={isFromCovid19ScreenerSurvey} technicalHelpDeskNumber={technicalHelpDeskNumber} serverData={serverData} userData={userData} userTags={this.userTags} />
                </div>
            </div>);
        }

        return (
            <div id="evisit-landing" className="container-fluid body-content">
                {body}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const pl = [];
    if (state.domain.pl) {
        state.domain.pl.forEach((proxy) => {
            pl.push(d.hydrateProxyUser(proxy));
        });
    }
    return {
        hasMyChart: state.domain.hm,
        epicEHRDown: state.common.epicEHRDown,
        hasAAL: state.session.serverData.enableAA && state.memberships.hasAA,
        loading: state.memberships.proxyListLoading,
        failure: state.memberships.proxyListFailure,
        proxyList: state.memberships.proxyList,
        isActiveFeature_EVisit: state.memberships.isActiveFeature_EVisit,
       /* eVisitCost: state.memberships.eVisitCostLabel,
        eVisitVendor: state.memberships.eVisitVendor,*/
        eVisit: state.memberships.currentUserEVisit,
        //eVisitZipGroupId: state.memberships.eVisitZipGroupId,
        //eVisitExternalId: state.memberships.eVisitExternalId,
        activeProfile: state.memberships.activeProfile,
        primaryUser: d.hydrateProxyUser(state.domain.pu),
        currentUser: d.hydrateProxyUser(state.domain.cu),
        serverData: state.session.serverData,
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber : "",
        technicalHelpDeskHours: state.session.serverData ? state.session.serverData.technicalHelpDeskHours : "",
        myProxies: pl,
        zipnosis: state.header.zipnosis,
        userIsSwitching: state.memberships.switchingProxyUser
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        switchToMyChartUser: (user, index, callback) => {
            dispatch({ type: types.SWITCH_USER_REDUCER, user, index });
            dispatch({ type: types.SWITCH_USER_SAGA, user, index, callback });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EVisit_latest);